import request from "@/api";

export function listAdvice(data) {
    return request({
        url: '/api/advice/getAdviceList',
        method: 'get',
        params: data
    })
}
export function saveAdvice(data) {
    return request({
        url: '/api/advice/saveAdvice',
        method: 'post',
        data: data
    })
}

export function getAdviceInfo(data) {
    return request({
        url: '/api/advice/getAdviceInfo',
        method: 'get',
        params: data
    })
}

export function deleteAdvice(data) {
    return request({
        url: '/api/advice/deleteAdvice',
        method: 'post',
        data: data
    })
}